var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, IconButton, Switch, Table } from '@dixa/lib-shared-habla';
import { useCallback, useEffect, useState } from 'react';
import { ratingApi } from 'apis/rating';
import { appActions } from 'app/app.actions';
import { languages } from 'app/utils/supportedLanguages';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
import { isResponseWithData } from 'utils/apis/axios';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
export const SurveyLanguageTableRow = (props) => {
    const [isEnabled, setIsEnabled] = useState(props.languageSettings.enabled);
    const [updateRatingSettings] = ratingApi.useLazyUpdateRatingSettingsQuery();
    const dispatch = useAppDispatch();
    const notify = useNotifications();
    const [deleteRatingSettings] = ratingApi.useLazyDeleteRatingSettingsQuery();
    const openDeleteModal = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const { isConfirmed } = yield dispatch(appActions.showModal({
            modal: {
                type: 'app:confirm',
                arg: {
                    title: 'Delete language?',
                    description: 'The CSAT language customization will be lost.',
                    confirm: {
                        label: 'Delete',
                    },
                },
            },
        }));
        if (isConfirmed) {
            try {
                const deleteResponse = yield deleteRatingSettings({
                    ratingSettingsId: props.languageSettings.id,
                }).unwrap();
                if (isResponseWithData(deleteResponse)) {
                    props.onDelete();
                }
                notify({
                    title: 'Success',
                    text: `The language customization has been deleted.`,
                    icon: 'done',
                    time: 5000,
                }, NotificationType.Success);
            }
            catch (error) {
                notify({
                    title: 'Error while deleting language customization.',
                }, NotificationType.Error);
            }
        }
    }), [deleteRatingSettings, dispatch, notify, props]);
    const handleOnEnabledChange = useCallback((enabled) => __awaiter(void 0, void 0, void 0, function* () {
        yield updateRatingSettings({
            id: props.languageSettings.id,
            enabled: enabled,
        });
        setIsEnabled(enabled);
    }), [props.languageSettings.id, updateRatingSettings]);
    useEffect(() => {
        setIsEnabled(props.languageSettings.enabled);
    }, [props.languageSettings.enabled, setIsEnabled]);
    const languageLabel = languages
        .filter(({ code }) => code == props.languageSettings.language)
        .map(({ label }) => label)
        .shift();
    return (_jsxs(Table.Tr, { children: [_jsx(Table.Td, { children: languageLabel !== null && languageLabel !== void 0 ? languageLabel : '-' }), _jsx(Table.Td, Object.assign({ align: "center" }, { children: _jsx(Switch, { name: "enable-language", value: "enable-language", checked: isEnabled, onChange: (e) => {
                        handleOnEnabledChange(e.target.checked);
                    } }) })), _jsx(Table.Td, { children: _jsxs(FlexBox, Object.assign({ flexDirection: "row" }, { children: [_jsx(IconButton, { variant: "tertiary", icon: "pen", onClick: () => { var _a; return props.handleGoToLanguage((_a = props.languageSettings.language) !== null && _a !== void 0 ? _a : 'en'); } }), _jsx(IconButton, { variant: "tertiary", icon: "trash", onClick: openDeleteModal })] })) })] }));
};
